import { IField, ISelectConfig, ISimpleChoice } from '../field2.data-model';
import { EnumOption, FieldDefinition, fieldDefinitionSchema } from './field-definition.schema';
import { ifieldTypeToPrimitive } from './kpi-config-mapping';

function isSelectConfig(config: unknown): config is ISelectConfig<unknown> {
  return (
    typeof config === 'object' && config !== null && Array.isArray((config as { values?: unknown }).values)
  );
}

/**
 * Pulls `EnumOption[]` from a renderer config when the renderer is a
 * select. Returns `undefined` for renderers that don't carry enum options
 * so the schema cast leaves `enumOptions` unset.
 */
function extractEnumOptions(rendererConfig: unknown): EnumOption[] | undefined {
  if (!isSelectConfig(rendererConfig)) {
    return undefined;
  }
  return rendererConfig.values
    .filter((c): c is ISimpleChoice<string | number> => c.value != null)
    .map((c) => ({
      value: String(c.value),
      label: c.displayName ?? String(c.value),
      group: c.group ?? undefined,
    }));
}

/**
 * Inbound mapper: legacy custom-field `IField` row → canonical
 * `FieldDefinition`. Terminates in `fieldDefinitionSchema.cast(...)` per
 * the FD-2794 cross-cutting rule.
 */
export function customFieldToFieldDefinition(cf: IField<unknown>): FieldDefinition {
  return fieldDefinitionSchema.cast(
    {
      key: cf.entityField,
      displayName: cf.displayName,
      description: cf.description ?? undefined,
      type: ifieldTypeToPrimitive(cf.type),
      format: cf.formMeta?.renderer?.type,
      sortOrder: cf.sortOrder ?? 0,
      isActive: true,
      createdAt: cf.createdAt ?? '',
      updatedAt: '',
      enumOptions: extractEnumOptions(cf.formMeta?.renderer?.config),
    },
    { stripUnknown: true }
  ) as FieldDefinition;
}
